/* VikingsBrand article reading mode: A-/A+ text scale, Paper (parchment) toggle, scroll progress bar. */
(function () {
  'use strict';
  function boot() {
    var root = document.documentElement;
    var scale = 1;
    document.querySelectorAll('[data-vb-read]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var a = btn.getAttribute('data-vb-read');
        if (a === 'paper') {
          var on = root.hasAttribute('data-vb-paper');
          if (on) { root.removeAttribute('data-vb-paper'); btn.setAttribute('aria-pressed', 'false'); }
          else { root.setAttribute('data-vb-paper', ''); btn.setAttribute('aria-pressed', 'true'); }
          return;
        }
        if (a === 'inc') scale = Math.min(1.4, scale + 0.1);
        else if (a === 'dec') scale = Math.max(0.85, scale - 0.1);
        root.style.setProperty('--vb-read-scale', scale);
      });
    });
    var bar = document.querySelector('[data-vb="reading-bar"]');
    if (bar) {
      var onScroll = function () {
        var h = document.documentElement.scrollHeight - window.innerHeight;
        var p = h > 0 ? Math.min(1, Math.max(0, window.scrollY / h)) : 0;
        bar.style.width = (p * 100) + '%';
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
